import { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';

const DEBUG = process.env['REACT_APP_DEBUG'];


const FormStateModal = (props: { formState: unknown }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { formState } = props;
  return DEBUG ? (
    <div className='__QSightForm_DEV mb-4'>
      <div>
        <button onClick={handleOpen} className='btn btn-primary'>
          Form Data
        </button>
        <Modal
          isOpen={open}
          onClose={handleClose}
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
          toggle={open ? handleClose : handleOpen}
        >
          <div >
            <ModalHeader toggle={open ? handleClose : handleOpen}>
              Form Debug
            </ModalHeader>
            <ModalBody>
              <div id='modal-modal-description' className='mt-2'>
                <pre>{JSON.stringify(formState, null, '  ')}</pre>
              </div>

            </ModalBody>
          </div>
        </Modal>
      </div>
    </div >
  ) : (
    <></>
  );
};

export default FormStateModal;
